/**
 * @author David Roman <david@inarix.com>
 * @file Description
 * @desc Created on 2021-04-09 5:23:38 pm
 * @copyright Inarix
 */

import { env } from "./config/environment";

export const API = env.api.baseUrl;
export const SALES_EMAIL = process.env.REACT_APP_EMAIL || "sales@inarix.com";

/**
 *  I will use only to test Fetching Data FAKEAPI is the local DB
 */
export const FAKEAPI = "http://localhost:4000";
